import I18n from 'hooks/useI18n';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as commonStateActions from 'redhotpie-shared-lib/actions/commonStateAction';
import { STYLE_MODAL } from 'redhotpie-shared-lib/constants/constants';

const withCommonStateAction = WrappedComponent => {
  const NewComponent = ({ commonStateActions, commonStateReducer, ...otherProps }) => {
    const openPopupPrivatePhoto = (userName, callback) => {
      commonStateActions.onShowConfirmModal({
        headerText: I18n.t('MemberProfileScreen.PhotoInPrivateGallery'),
        messageConfirm: I18n.t('MemberProfileScreen.SendAMessageAndRequest', {
          userName,
        }),
        okText: I18n.t('Btn.RequestAccess'),
        onOkAction: () => {
          commonStateActions.onCloseConfirmModal();

          if (callback) {
            callback();
          }
        },
        cancelText: I18n.t('Btn.MaybeLater'),
        classNames: STYLE_MODAL.BLOCK_MODAL,
      });
    };
    const updateAutoCloseModal = () => {
      commonStateActions.updateCommonStateReducerSuccess({
        autoCloseRulesModal: false,
      });
    };
    return (
      <WrappedComponent
        commonStateActions={commonStateActions}
        commonStateReducer={commonStateReducer}
        openPopupPrivatePhoto={openPopupPrivatePhoto}
        updateAutoCloseModal={updateAutoCloseModal}
        {...otherProps}
      />
    );
  };

  NewComponent.displayName = `withCommonStateAction(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  const mapStateToProps = state => ({
    commonStateReducer: state.commonStateReducer,
  });

  const mapDispatchToProps = dispatch => ({
    commonStateActions: bindActionCreators(commonStateActions, dispatch),
  });

  return connect(mapStateToProps, mapDispatchToProps)(NewComponent);
};

export default withCommonStateAction;
